import { parseCurrency } from "utils"

  
const profilesTitles = {
    male:'Menino',
    female:'Menina'
}

export const parseProfile = item => {
    return {
        id: item.id,
        name: item.name,
        avatar: { image: item?.picture?.url || null },
        gender: { title: profilesTitles[item.gender], type: item.gender }
    }
}

export const parseProfileImage = item => {
    return {
        id: item.id,
        name: item.name,
        image: item.url 
    }
}
 


const plans = {
    'Mensal':{
        type:'montly_plan',
        title:'Plano Mensal',
        image:'/background/background-5.png',
        action:`Plano Mensal - R$ 29,90 - Por Mês`,
        text:`Este plano é automaticamente renovado a cada mês`,
        renew:`R$29,90/mês`,
        variant:{ primary:true },
        value:29.9,
        installment: false
    },
    'Anual':{
        type:'yearly_plan',
        title:'Plano Anual',
        image:'/background/background-6.png',
        action:`Plano Anual - R$ 990,90 - Por Mês`,
        text:`Este plano é automaticamente renovado a cada 12 meses`,
        renew:`R$218,80/ano`,
        variant:{ secondary:true }, 
        value:990.9,
        installment: true
    }
}

export const parsePlan = (item, backgrounds) => {
    console.log('🔍 parsePlan - item recebido:', item)
    console.log('🔍 parsePlan - item.title:', item.title)
    console.log('🔍 parsePlan - item.value:', item.value)
    console.log('🔍 parsePlan - plans[item.title]:', plans[item.title])
    
    // Garantir que o valor seja o correto
    const planValue = item.value && item.value > 0 ? item.value : plans[item.title]?.value
    
    const result = {
        ...plans[item.title],
        ...item,
        value: planValue, // Forçar o valor correto
        text: item.descriptor,
        action:`Plano ${item.title} - ${ parseCurrency(item.title === 'Anual' ? parseFloat(planValue / 1)  : planValue) } -- `,
        renew:`${ parseCurrency(planValue) }/${ item.title === 'Anual' ? 'ano' : 'mês' }`,
        image: backgrounds?.find(fnd => fnd.locale === plans[item.title]?.type)?.url
    }
    
    console.log('🔍 parsePlan - resultado final:', result)
    return result
}











const categoriesOption = {
    'Filme':{
        title:'Filme',
        color:'blue'
    },
    'Série':{
        title:'_',
        color:'yellow'
    },

    'Musical':{
        title:'Musical',
        color:'blue'
    },
    'Educativo':{
        title:'Educativo',
        color:'green'
    }
}

export const parseBanner = item => { 
    return { 
        id: item?.featured_show?.data?.id,
        title: item?.featured_show?.data?.attributes?.name,
        image: item?.featured_banner?.data?.attributes?.url,
        category: categoriesOption['Série'] || {}
    }
}

/* 
const categoryIcons = {
    'robo': { image:'/images/users/male-1.png' },
    'Educativos': { icon:'art' },
    'Filmes': { icon:'popcorn' }
}


export const parseCategory = item => { 
    return { 
        title: item?.attributes?.name, 
        id: item?.id, 
        icon: categoryIcons[item?.attributes?.name] || '/images/users/male-1.png'
        //icon: item.url || false
        //image: item.url
    }
} */

    // Definindo o ícone e a imagem para cada categoria
const categoryIcons = {
    'ChatBox': { icon: 'series', image: '/images/card_nando_idioma.png' }, // Nando (Idiomas)
    'ChatBox03': { icon: 'series', image: '/images/card_lulu_idioma.png' }, // Lulu (Idiomas)
    'ChatBox05': { icon: 'series', image: '/images/card_nando_biblia.png' }, // Nando (Bíblico)
    'ChatBox07': { icon: 'series', image: '/images/card_lulu_biblia.png' }, // Lulu (Bíblico)
    'Pra Você': { icon: 'popcorn', image: '/images/asset_test.png' }, // Caminho para a imagem Filmes
    'Férias': { icon: 'series', image: '/images/asset_test.png' }, // Caminho para a imagem Série
    'Educativos': { icon: 'series', image: '/images/asset_test.png' }, // Caminho para a imagem Série
    'Conteúdos': { icon: 'series', image: '/images/asset_test.png' }, // Caminho para a imagem Série
    'Smilinguido': { icon: 'series', image: '/images/asset_test.png' } // Caminho para a imagem Série
};

export const parseCategory = item => { 
    const categoryName = item?.attributes?.name;
    return { 
        title: categoryName, 
        id: item?.id, 
        icon: categoryIcons[categoryName]?.icon || 'default-icon', // Caso não tenha ícone
        image: categoryIcons[categoryName]?.image || '/icons/default.svg' // Caminho padrão se não houver imagem
    };
};

const collectionResources = {
    'Meus Favoritos':{ icon:'heart', image: '/images/users/male-1.png' },
    'As 20 Músicas + Vistas':{ icon:'sound', image: '/images/users/male-2.png' },
    'Cante e Dance':{ icon:'dance', image: '/images/users/female-3.png' },
}

export const parseCollection = item =>  {
    return {
        id: item?.id, 
        title: item?.attributes?.name, 
        ...(collectionResources[item?.attributes?.name] || {}),
        videos: item?.attributes?.stream_shows?.data?.length ? item?.attributes?.stream_shows?.data?.map(parseVideo) : [],
        image: item?.attributes?.icon?.data?.attributes?.url ? item?.attributes?.icon?.data?.attributes?.url : null
    }
}

export const parseVideo = item => {
    return { 
        id: item?.id, 
        title: item?.attributes?.name || item?.name, 
        description: item?.attributes?.description || item?.description, 
        cover: item?.attributes?.thumbnail?.data?.attributes?.url || item?.thumbnail?.url, 
        // category_id:1 
    }
}

export const parseVideoShow = item => {
    return { 
        ...item,
        title:item.name,
        cover: item?.wide_picture?.url , 
        thumb: item?.thumbnail?.url , 
        // category_id:1 
    }
}
